<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5UFvIT/tc-custom/9781416538318.jpg?1730491662927" alt="This image is the cover for the book How to Abduct a Highland Lord, The MacLean Curse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Abduct a Highland Lord, The MacLean Curse
      </h1>
      <p class="bookDescription body article font2">
        <b>In a delightfully sexy and witty series, <i>New York Times </i>and<i> USA TODAY</i> bestselling author Karen Hawkins creates an unforgettable couple locked in a marriage that begins with a desperate feud—and ends in seduction.</b><br/><br/>It’s hardly the type of wedding Fiona MacLean dreamed of. No family, no guests, just a groom who’s been dragged—literally—to the altar. But if marriage to Black Jack Kincaid, the handsome wastrel she’d sworn never to see again, will avert a bloody war between their clans, so be it. Surely she can share his bed without losing her heart…<br/><br/>Known throughout Scotland and London as a wild rogue, Jack is accustomed to waking in dire situations, but…<i>married? </i>Long ago, he and Fiona reveled in a youthful passion. Now, the fiery, sensual lass is his once more. And though their marriage is in name only, Jack is determined to win her forever—body and soul…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Hawkins
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> and <I>USA TODAY&#160;</I>bestselling author Karen Hawkins writes novels that have been praised as touching, witty, charming, and heartwarming. A native Southerner who grew up in the mountains of East Tennessee where storytelling is a way of life, Karen recently moved to frosty New England with her beloved husband and multiple foster dogs. The Dove Pond series is a nod to the thousands of books that opened doors for her to more adventures, places, and discoveries than she ever imagined possible.&#160;To find out more about Karen, check in with her at Facebook.com/AuthorKarenHawkins, on Instagram @KarenHawkinsAuthor, and on her website&#160;KarenHawkins.com.<BR><BR>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9564c1e